import { JSX, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../../DataTable/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../../data/Constants';
import { getCountryList } from '../../../store/states/MarketSlice';
import { getPriceListMap } from '../../../store/states/PriceSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store';
import { useApiError } from '../../../hooks';

import type { IManagementProps } from '../../../../types';

export const PriceListMap = (props: IManagementProps): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.PriceListMapKey);

  useEffect(() => {
    dispatch(getCountryList());
  }, [dispatch]);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.priceListMap')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.PriceListMap}
        getDataList={getPriceListMap}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
